import { CSSProperties, ReactNode, Suspense } from "react"
import { SidebarProvider } from "@ui/shad"

import { EmailConnectedReturnToast } from "@/components/integrations/email-connect-notice"
import { Header } from "@/components/layout/header"
import { IntegrationBanners } from "@/components/layout/integration-banners"
import { RecordingContainer } from "@/components/layout/recording-container"
import { Sidebar } from "@/components/layout/sidebar"
import { SlantaIntroductionBanner } from "@/components/slanta/introduction-banner"

// 48px is the height of the header

export default function LayoutContainer({ children }: { children: ReactNode }) {
  return (
    <SidebarProvider collapseBelow={1440} style={{ "--sidebar-width-icon": "3rem" } as CSSProperties}>
      <Sidebar />
      <main className="flex h-screen w-full flex-col overflow-hidden">
        <Header />
        <SlantaIntroductionBanner />
        <IntegrationBanners />
        {children}
        <RecordingContainer />
      </main>
      <Suspense fallback={null}>
        <EmailConnectedReturnToast />
      </Suspense>
    </SidebarProvider>
  )
}
